export default __webpack_public_path__ + "static/media/coloris-logo.03c2077c.svg";